<script>
import Dialog from "primevue/dialog";
import services from "@shared/services";
import ScrollPanel from "primevue/scrollpanel";
export default {
  name: "PolicyModal",
  components: {
    Dialog,
    ScrollPanel,
  },
  data() {
    return {
      policy: {},
      loaded:false,
    };
  },

  methods: {
    async getPolicy() {
      await services.staticPostService.getPolicy(this.type).then((data) => {
        this.policy = data.data.data;
      });
    },
    closeDialog(trigger = false) {
      this.$emit("onSubmit", trigger);
      this.$emit("update:visible", false);
    },
  },
  watch: {
    visible(value) {
      if(value==true){
        this.getPolicy();
        this.loaded = true;
      }
      
    },
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    check: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "policy",
    },
  },
};
</script>

<template>
  <div class="d-none">
    <Dialog
      :visible="visible"
      modal
      class="container"
      :style="{ height: '100%' }"
    >
      <template #header> </template>
      <template #container="{}">
        <div class="wrap wrap-policy">
          <div class="content row">
            <div class="left col-12 col-md-7 d-none d-sm-block">
              <img :src="imageLink(policy.image)" class="w-100" />
            </div>
            <div class="right col-12 col-md-5">
              <div class="position-relative content-height">
                <div class="w-100 position-absolute h-100">
                  <ScrollPanel
                    style="width: 100%; height: 100%; overflow-y: hidden"
                  >
                    <div v-html="policy.content"></div>
                  </ScrollPanel>
                </div>
              </div>
            </div>
          </div>
          <div class="footer2">
            <div class="text-end">
              <template v-if="check">
                <button
                  class="btn px-4 btn-link"
                  @click.prevent="closeDialog(false)"
                >
                  {{ $t("login.no_allow") }}
                </button>
                <button
                  class="btn px-4 btn-allow btn-primary"
                  @click.prevent="closeDialog(true)"
                >
                  {{ $t("login.allow") }}
                </button>
              </template>
              <button
                v-else
                class="btn btn-allow px-4 btn-primary"
                @click.prevent="closeDialog"
              >
                {{ $t("global.exit") }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>
